import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Topbar from "../../Component/Topbar/Topbar";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { toggle_off, toggle_on } from "../../assets/img";

const RolesAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const type = location?.state?.type;
  const isViewMode = type === "view";

  const permissionGroups = [
    {
      title: "Super Admin",
      permissions: ["List", "Add", "Edit", "View", "Status"],
    },
    {
      title: "Inventory",
      permissions: ["List", "Add", "Edit", "View", "Status"],
    },
    {
      title: "Technical",
      permissions: ["List", "Add", "Edit", "View", "Status"],
    },

    {
      title: "Manager",
      permissions: ["List", "Add", "Edit", "View", "Status"],
    },
  ];

  const [toggles, setToggles] = useState(() => {
    const initial = {};
    permissionGroups.forEach((group, i) => {
      initial[i] = { main: false, subs: group.permissions.map(() => false) };
    });
    return initial;
  });

  const [allSelected, setAllSelected] = useState(false);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "8px",
      borderColor: "#1A77BC",
      minHeight: "40px",
      fontSize: "14px",
    }),
  };

  const {
    control,
    formState: { errors },
  } = useForm({
    defaultValues: { region: null },
  });

  const regionOptions = [
    { value: "north", label: "Super Admin" },
    { value: "south", label: "Inventory" },
    { value: "east", label: "Technical" },
    { value: "west", label: "Regional Manager" },
    { value: "north", label: "Service Engineer" },
  ];

  const toggleSelectAll = () => {
    const newState = !allSelected;
    const updated = {};
    permissionGroups.forEach((group, i) => {
      updated[i] = {
        main: newState,
        subs: group.permissions.map(() => newState),
      };
    });
    setToggles(updated);
    setAllSelected(newState);
  };

  const toggleMain = (gIndex) => {
    setToggles((prev) => {
      const newMain = !prev[gIndex].main;
      return {
        ...prev,
        [gIndex]: {
          main: newMain,
          subs: prev[gIndex].subs.map(() => newMain),
        },
      };
    });
  };

  const toggleSub = (gIndex, pIndex) => {
    setToggles((prev) => {
      const newSubs = [...prev[gIndex].subs];
      newSubs[pIndex] = !newSubs[pIndex];
      const allOn = newSubs.every(Boolean);
      return {
        ...prev,
        [gIndex]: { main: allOn, subs: newSubs },
      };
    });
  };

  return (
    <div>
      <Topbar
        header={isViewMode ? "Roles" : "Roles "}
        subHead={isViewMode ? "Add" : "Edit "}
      />
      <div className="container_fluit1 px-4 py-3">
        <div className="col-md-5 mb-4">
          <Controller
            control={control}
            name="region"
            rules={{ required: "Region is required" }}
            render={({ field }) => (
              <div>
                <label className="fw-bold mb-1">Roles Type</label>
                <Select
                  {...field}
                  options={regionOptions}
                  placeholder="Select Region"
                  styles={customStyles}
                  isDisabled={isViewMode}
                />
                {errors.region && (
                  <p className="text-danger mt-1">{errors.region.message}</p>
                )}
              </div>
            )}
          />
        </div>
        <div className="d-flex ac-jb">
          {" "}
          <h4 className="fw-bold mb-3">Permissions</h4>
          <div onClick={toggleSelectAll} style={{ cursor: "pointer" }}>
            <img
              src={allSelected ? toggle_on : toggle_off}
              alt="toggle all"
              width={40}
            />
          </div>
        </div>

        <div className="row">
          {permissionGroups.map((group, gIndex) => (
            <div className="col-md-3 mb-4" key={gIndex}>
              <div className="d-flex ac-js gap-2 mb-3">
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleMain(gIndex)}
                >
                  <img
                    src={toggles[gIndex].main ? toggle_on : toggle_off}
                    alt="toggle main"
                    width={40}
                  />
                </div>
                <p className="f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20 mb-0">
                  {group.title}
                </p>
              </div>

              <div className="d-flex flex-column gap-3 ">
                {group.permissions.map((perm, pIndex) => (
                  <div key={pIndex} className="d-flex ac-js gap-2">
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleSub(gIndex, pIndex)}
                    >
                      <img
                        src={
                          toggles[gIndex].subs[pIndex] ? toggle_on : toggle_off
                        }
                        alt="toggle sub"
                        width={40}
                      />
                    </div>
                    <span className="f1 fs-sm-13 fs-md-15 fs-lg-15 fs-xl-16 fs-xxl-18 mb-0">
                      {perm}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="d-flex ac-jb ">
          <button className="back_btn f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20">
            Back
          </button>
          <button className="Add_btn f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20">
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default RolesAdd;
